import React, { Component } from 'react';
import PropTypes from "prop-types";
import Media from 'react-media';

import { BackMethod } from './functions/BackMethod';
import { ForwardMethod } from './functions/ForwardMethod';
import DesktopImg from './desktop';
import MobileImg from './mobile'
import GalleryModal from './modal/index'

import { H3 } from 'styled';

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.windowGlobal = typeof window !== 'undefined' && window;
  }

  state = {
    open: false,
    img: '',
    imgArray: [],
    desktop: ''
  };

  componentWillMount() {
    this.resize();
  }

  componentDidMount() {
    this.resize();
    this.windowGlobal.addEventListener('load', this.resize);
    this.windowGlobal.addEventListener('resize', this.resize);
  }

  resize = () => {
    if (this.windowGlobal.innerWidth > 576) {
      this.setState({ desktop: true });
    } else {
      this.setState({ desktop: false });
    }
  };

  onOpenModal = img => {
    this.setState({ open: true, img });
  };

  onOpenModalMulti = (img, imgArray) => {
    const filteredImages = imgArray.filter(el => el.className !== "empty");

    const images = filteredImages.map((item, index) => {

        return {
          id: index,
          url: item.gallery_image.url,
          alt: item.gallery_image.alt,
          ...item
        }
    });

    this.setState({ open: true, img, imgArray: images },);
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  onBackBtn = (img, imgArray) => {
    const newImg = BackMethod(img, imgArray);
    
    this.setState({ img: newImg.url });
  };

  onForwardBtn = (img, imgArray) => {
    const newImg = ForwardMethod(img, imgArray);

    this.setState({ img: newImg.url });
  };

  render() {
    const { open, img, imgArray, desktop } = this.state;

    let modalSize, gallery;
    
    this.windowGlobal.innerWidth > 767 
    ? (modalSize = ['700px', '500px']) 
    : (modalSize = ['320px', '250px'])

    return (
      this.props.gallery[0].items.length > 0 &&
        <React.Fragment>
          <a id="gallery" style={{marginTop: '-80px', position: 'absolute'}} />
          <H3 
            fontSize="24px"
            fontWeight="400"
            fontColor="rgb(70,52,78)"
          >
            {this.props.title}
          </H3>
          <Media query="(min-width: 640px)">
            {matches =>
                matches ? (
                  <DesktopImg
                    gallery={this.props.gallery}
                    onOpenModalMulti={this.onOpenModalMulti}
                  />
                
                ) : (
                  <MobileImg
                    gallery={this.props.gallery}
                    onOpenModalMulti={this.onOpenModalMulti}
                  />
                )
              }
          </Media>
          <GalleryModal 
            open={open}
            onCloseModal={this.onCloseModal}
            imgArray={imgArray}
            img={img}
            onBackBtn={this.onBackBtn}
            onForwardBtn={this.onForwardBtn}
          />
        </React.Fragment>
    );
 }
}
export default Gallery

Gallery.propTypes = {
  gallery: PropTypes.array,
  title: PropTypes.object
}